module.exports = __webpack_public_path__ + "static/media/hero_image.ba748c0d.png";